import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Logo } from '../components/Logo/Logo';
import { Button } from '../components/Button/Button';
import { AppsModule } from '../modules/apps/AppsModule';
import { MarketplaceModule } from '../modules/marketplace/MarketplaceModule';
import './Dashboard.css';

type View = 'apps' | 'marketplace' | 'settings';

const Dashboard: React.FC = () => {
  const { user, logout } = useAuth();
  const [currentView, setCurrentView] = useState<View>('apps');

  const navItems = [
    { id: 'apps' as View, label: 'My Apps', icon: '📱' },
    { id: 'marketplace' as View, label: 'Marketplace', icon: '🛒' },
    { id: 'settings' as View, label: 'Settings', icon: '⚙️' }
  ];

  const renderContent = () => {
    switch (currentView) {
      case 'apps':
        return <AppsModule />;
      case 'marketplace':
        return <MarketplaceModule />;
      case 'settings':
        return (
          <div className="settings-module">
            <h1>Settings</h1>
            <p>Settings page coming soon...</p>
          </div>
        );
      default:
        return <AppsModule />;
    }
  };

  return (
    <div className="dashboard">
      <nav className="dashboard-nav">
        <div className="dashboard-nav__header">
          <Logo variant="light" size="medium" />
        </div>
        
        <div className="dashboard-nav__menu">
          {navItems.map(item => (
            <button
              key={item.id}
              className={`nav-item ${currentView === item.id ? 'nav-item--active' : ''}`}
              onClick={() => setCurrentView(item.id)}
            >
              <span className="nav-item__icon">{item.icon}</span>
              <span className="nav-item__label">{item.label}</span>
            </button>
          ))}
        </div>

        <div className="dashboard-nav__footer">
          <div className="user-info">
            <div className="user-avatar">
              {user?.profile?.name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.profile?.name || 'User'}</div>
              <div className="user-email">{user?.profile?.email || ''}</div>
            </div>
          </div>
          
          <Button variant="ghost" size="small" fullWidth onClick={logout}>
            Sign Out
          </Button>
        </div>
      </nav>

      <main className="dashboard-main">
        <div className="dashboard-content">
          {renderContent()}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;